import { createRoute, useNavigate, useParams, useSearch } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { ShoppingListDetail } from "@/features/shopping/components/shopping-list-detail";
import { PageContainer } from "@fleet/ui";

interface ShoppingDetailSearch {
  /** Opens the "share list" dialog (`?share=1`). */
  share?: boolean;
}

function ShoppingListDetailPage() {
  const params = useParams({ from: "/_app/shopping/$listId" });
  const search = useSearch({ from: "/_app/shopping/$listId" });
  const navigate = useNavigate();

  // The "share" dialog is deep-linkable (`?share=1`): the URL is the source of
  // truth for opening/closing. `replace` avoids bloating the history.
  const setShareOpen = (open: boolean): void => {
    if (open === Boolean(search().share)) {
      return;
    }
    void navigate({
      to: "/shopping/$listId",
      params: { listId: params().listId },
      search: open ? { share: true } : {},
      replace: true,
    });
  };

  return (
    <PageContainer maxWidth="3xl">
      <ShoppingListDetail
        listId={params().listId}
        shareOpen={Boolean(search().share)}
        onShareOpenChange={setShareOpen}
      />
    </PageContainer>
  );
}

export const shoppingListDetailRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/shopping/$listId",
  validateSearch: (search: Record<string, unknown>): ShoppingDetailSearch => ({
    // Include the NUMBER 1: TanStack auto-parses `?share=1` as number 1 (not a string);
    // without this case the param was discarded at boot and the share overlay
    // did not open via deep link (CC-18).
    share:
      search.share === true || search.share === 1 || search.share === "1" || search.share === "true"
        ? true
        : undefined,
  }),
  component: ShoppingListDetailPage,
});
